import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  success: '',
  fetchedMemberInfo: null,
  isSuccess: false,
};

export default function fetchTeamMember(state = initialState, action) {
  switch (action.type) {
    case actionConstants.FETCH_MEMBER_REQUEST:
      return {
        ...state,
        isfetching: true,
        isSuccess: false,
      };
    case actionConstants.FETCH_MEMBER_SUCCESS:
      return {
        ...state,
        fetchedMemberInfo: action.payload,
        isfetching: false,
        isSuccess: true,
      };
    case actionConstants.FETCH_MEMBER_FAILURE:
      return {
        ...state,
        error: action.error,
        isfetching: false,
        isSuccess: false,
      };
    case actionConstants.CLEAR_STATE:
      return {
        ...state,
        isfetching: false,
        isSuccess: false,
      };
    case actionConstants.RESET_TEAM_REDUCER: {
      return {
        ...state,
        isSuccess: false,
        isfetching: false,
      };
    }
    default:
      return state;
  }
}
